import dayjs from 'dayjs';
import { useIdentityStore } from '@/stores/identity';
import { formatDate } from '@/utils/dateUtils';

export function useDateUtils() {
  const identityStore = useIdentityStore();

  function convertTimestampToUserTimezone(timestamp, format) {
    if (timestamp) {
      const tz = identityStore?.identity?.time_zone_name;
      if (tz) {
        return dayjs.isDayjs(timestamp)
          ? timestamp.tz(tz).format(format)
          : dayjs(timestamp).tz(tz).format(format);
      }
      return dayjs.isDayjs(timestamp)
        ? timestamp.local().format(format)
        : dayjs(timestamp).local().format(format);
    }
    return '';
  }

  function getFormattedDateFromRange(range) {
    const endYear = formatDate(range?.end, 'yyyy');
    const isCurrentYear = endYear === formatDate(new Date(), 'yyyy');
    const isSameYear = formatDate(range?.start, 'yyyy') === endYear;
    let endDateFormat;

    if (formatDate(range?.start, 'MMM, yyyy') === formatDate(range?.end, 'MMM, yyyy')) {
      endDateFormat = isSameYear && isCurrentYear ? 'dd' : 'dd, yyyy';
    } else {
      endDateFormat = isSameYear && isCurrentYear ? 'MMM dd' : 'MMM dd, yyyy';
    }

    const endDate = formatDate(range?.end, endDateFormat);
    const isSameDay = endDate === formatDate(range?.start, isCurrentYear ? 'dd' : 'dd, yyyy');
    const startDateFormat = isSameYear && (isCurrentYear || !isSameDay) ? 'MMM dd' : 'MMM dd, yyyy';
    const startDate = formatDate(range?.start, startDateFormat);

    if (isSameDay) {
      // If the end date is the same day as the start date, we don't need to show the end date
      return `${startDate}`;
    }
    return `${startDate} - ${endDate}`;
  }

  return { convertTimestampToUserTimezone, getFormattedDateFromRange };
}
